/**
 * Text Formatting Utilities
 * Handles text transformation and formatting detection
 */

/**
 * Check if text contains markdown formatting
 */
export const containsMarkdown = (text: string): boolean => {
  const markdownPatterns = [
    /\*\*.*?\*\*/,           // Bold
    /\*.*?\*/,               // Italic
    /_.*?_/,                 // Italic underscore
    /^#{1,6}\s/m,            // Headers
    /^\s*[-*+]\s/m,          // Unordered lists
    /^\s*\d+\.\s/m,          // Ordered lists
    /\[.*?\]\(.*?\)/,        // Links
    /`.*?`/,                 // Inline code
    /```[\s\S]*?```/,        // Code blocks
    /^>\s/m,                 // Blockquotes
  ];

  return markdownPatterns.some(pattern => pattern.test(text));
};

/**
 * Normalize line breaks for consistent display
 */
export const normalizeLineBreaks = (text: string): string => {
  return text
    .replace(/\r\n/g, '\n')     // Windows to Unix
    .replace(/\r/g, '\n')        // Old Mac to Unix
    .replace(/\n{3,}/g, '\n\n'); // Max 2 consecutive line breaks
};

/**
 * Truncate text with ellipsis
 */
export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trim() + '...';
};

/**
 * Extract first sentence from text
 */
export const getFirstSentence = (text: string): string => {
  const match = text.match(/^[^.!?]+[.!?]/);
  return match ? match[0].trim() : text.split('\n')[0].trim();
};
